import './style.scss';

import Catalogue from './modules/catalogue';
import CataloguePc from './modules/catalogue-pc';
import SettingCatalogue from './modules/setting-catalogue';
import HideLoader from './modules/hide-loader';

(function () {
	SettingCatalogue(() => {

		const mediaQuery = window.matchMedia('(min-width: 769px)');

		const handle = (mq) => {
			if (mq.matches) {
				CataloguePc();
			} else {
				Catalogue();
			}
		}

		handle(mediaQuery);

		mediaQuery.addListener(handle);

		HideLoader();
	})
}());